import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ConditionIndicesOverviewComponent from './ConditionIndicesOverviewComponent';
import * as actions from './actions';
import { getModel } from './selectors';
import { setSelectedAssetAction, setSelectedAssetDetailsAction } from './AssetOverview/actions';
import { setSelectedNotification } from '../../PowertrainOverview/Header/NotificationDropdown/actions';
import { getHierarchyConditionIndices } from './HierarchyView/actions';
import { setActiveTabV2 } from '../../PowertrainAssetDetails/DetailedInformation/actions';

const ConditionIndicesOverviewContainer = (props) => {

    const {
        selectedFilters,
    } = props.model;

    const {
        updateSelectedFilters,
    } = props.actions;

    useEffect(() => {
        updateSelectedFilters(props.model.selectedFilters);
    }, [selectedFilters]);

    useEffect(() => {
        return () => {
            // props.actions.clearStore();
            // props.actions.setSelectedAssetAction(null);
            // props.actions.setSelectedAssetDetailsAction(null);
            // props.actions.resetFilters();
        };
    }, []);
    return <ConditionIndicesOverviewComponent {...props} />;
};

ConditionIndicesOverviewContainer.propTypes = {
    model: PropTypes.shape({
        selectedNotification: PropTypes.object,
        selectedFilters: PropTypes.object
    }),
    actions: PropTypes.shape({
        getAssetConditionIndicesRequest: PropTypes.func,
        updateSelectedFilters: PropTypes.func,
        setSelectedNotification: PropTypes.func,
        getHierarchyConditionIndices: PropTypes.func
    })
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({
            ...actions,
            setSelectedAssetAction,
            setSelectedAssetDetailsAction,
            setSelectedNotification,
            getHierarchyConditionIndices,
            setActiveTabV2
        }, dispatch)
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConditionIndicesOverviewContainer);
